
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :saveAndAddOtherButtonEnabled="true"
    @new-confirm-and-add-other-action="createEntry(true)"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_GOAL_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.goal;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(goal, saveAndAddOther=false) {
      // console.log("SUBCULTURE", goal, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(goal, this.entry.validations));
      this.pageLoading = true;
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(goal, this.entry.validations);
      // console.log("create, val", this.entry.validations);
      // console.log("create", filtered);

      filtered.itemGoals.forEach(element => {
        delete element.code;
        delete element.item;
        delete element.totalPrice;
        delete element.goalTotalPrice;
        delete element.volume;
        delete element.previousQuantity;
        delete element.previousSalePrice;
        element.itemGoals.forEach(item => {
          delete item.__typename;
          delete item.id;
          delete item.packaging;
          delete item.price;
          delete item.totalPrice;
          delete item.volume;
          delete element.previousQuantity;
          delete element.previousSalePrice;
          item.quantity = parseFloat(item.quantity);
          // delete item.item;
        });
      });
      // console.log("create", filtered);
      this.$apollo
        .mutate({
          mutation: CREATE_GOAL_MUTATION,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.createGoal.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createGoal.goal);
            if (saveAndAddOther) {
              this.loadServerEntry();
              this.$refs.baseNew.newDialog = true;
            }
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function(addAnother = false) {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry, addAnother);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_GOAL_QUERY = gql `
  {
    accountContext{
      goal {
        id
        harvestId
        validations
      }
      allHarvests {
        id
        name
      }
      allMyCustomers{
        id
        name
      }
    } 
  }
`;

const CREATE_GOAL_MUTATION = gql `
  mutation($input: GoalCreateInputObject!) {
    createGoal(input: $input) {
      goal {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

